import React, { useEffect, useState } from 'react';

import { Accordion } from '@radix-ui/react-accordion';
import { useMeasure } from 'react-use';

// TODO: All of these imports are currently "Groups-only".
// Eventually, both `Groups` and `Group` can share the same components
// once everything utilizes `useNftFilter()`.
import { CollectionsFilterContentGroups } from './GroupFilterCollections/CollectionsFilterContentGroups';
import { GroupsFilterOwnership } from './GroupFilterOwnership';
import { GroupFiltersFloorPrice } from './GroupFiltersFloorPrice';

const REMAINING_HEIGHT_OFFSET = 75;

export const GroupsFilters = () => {
    const [parentHeight, setParentHeight] = useState(0);
    const [remainingHeight, setRemainingHeight] = useState(0);
    const [childrenRef, { height: childrenHeight }] = useMeasure<HTMLDivElement>();

    useEffect(() => {
        setParentHeight(window.innerHeight);
    }, []);

    useEffect(() => {
        if (parentHeight !== 0) {
            let finalHeight = parentHeight - childrenHeight - REMAINING_HEIGHT_OFFSET;

            // TODO: Why is this `height` setting necessary?
            // Can it not be done with CSS?
            if (finalHeight < 160) finalHeight = 160;

            setRemainingHeight(finalHeight);
        }
    }, [parentHeight, childrenHeight]);

    return (
        <Accordion id="groups-filters" type="multiple" defaultValue={['0', '1', '2']}>
            <div ref={childrenRef}>
                <GroupsFilterOwnership value={'0'} />
                <GroupFiltersFloorPrice index={'1'} />
            </div>

            <CollectionsFilterContentGroups value={'2'} height={remainingHeight || 160} />
        </Accordion>
    );
};
